export default "__VITE_ASSET__6fl0jT5W__"